import { ViewModel, View, ObservableArray } from "binder"
import { ControlPlanReportView } from "./controlPlanReport-view"
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import moment from "moment";

export class ControlPlanReportViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'گزارش طرح کنترل';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.rows = ObservableArray.create<SingleRow>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.loadReportRows(filteringInformation), 30);
    }
    GetDefaultView(): View<ViewModel> {
        return new ControlPlanReportView();
    }
    public getTypeId(): string {
        return "VM-88B2166F-3C79-46AB-B65F-F9E0B1A7603A"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set rows(v: ObservableArray<SingleRow>) { this._rows = v; } public get rows(): ObservableArray<SingleRow> { return this._rows; } private _rows: ObservableArray<SingleRow>;

    async refresh() {
        await this.loader.refresh();
    }
    async loadReportRows(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer('/Complex/ControlPlanService/GetControlPlanReport', {
                FilteringInformation: filteringInformation
            });

            this.rows.update(...serverResult.Rows.map((item, index) => {
                let row: SingleRow = new SingleRow(this);
                row.index = index + 1;
                row.productName = item.ProductName;
                row.productCode = item.ProductCode;
                row.groupName = item.GroupName;
                row.versionNo = item.VersionNo;
                row.measureParameterName = item.MeasureParameterName;
                row.minimum = item.Minimum;
                row.maximum = item.Maximum;
                row.supplierName = item.SupplierName;
                row.creatorPersonnelFullName = item.CreatorPersonnelFullName;
                row.creationDateTime = item.CreationDateTime;
                row.lastEditorPersonnelFullName = item.LastEditorPersonnelFullName;
                row.lastEditDateTime = item.LastEditDateTime;
                return row;
            }));

            return new PaginationInfo(serverResult.PaginationInfo?.CurrentPage, serverResult.PaginationInfo?.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
}

export class SingleRow extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set groupName(v: string) { this._groupName = v; } public get groupName(): string { return this._groupName; } private _groupName: string;
    public set versionNo(v: number) { this._versionNo = v; } public get versionNo(): number { return this._versionNo; } private _versionNo: number;
    public set measureParameterName(v: string) { this._measureParameterName = v; } public get measureParameterName(): string { return this._measureParameterName;} private _measureParameterName: string;
    public set minimum(v: number) { this._minimum = v; } public get minimum(): number { return this._minimum; } private _minimum: number;
    public set maximum(v: number) { this._maximum = v; } public get maximum(): number { return this._maximum; } private _maximum: number;
    public set supplierName(v: string) { this._supplierName = v; } public get supplierName(): string { return this._supplierName; } private _supplierName: string;
    public set creatorPersonnelFullName(v: string) { this._creatorPersonnelFullName = v; } public get creatorPersonnelFullName(): string { return this._creatorPersonnelFullName;} private _creatorPersonnelFullName: string;
    public set creationDateTime(v: moment.Moment) { this._creationDateTime = v; } public get creationDateTime(): moment.Moment { return this._creationDateTime;} private _creationDateTime: moment.Moment;
    public set lastEditorPersonnelFullName(v: string) { this._lastEditorPersonnelFullName = v; } public get lastEditorPersonnelFullName(): string { return this._lastEditorPersonnelFullName;} private _lastEditorPersonnelFullName: string;
    public set lastEditDateTime(v: moment.Moment) { this._lastEditDateTime = v; } public get lastEditDateTime(): moment.Moment { return this._lastEditDateTime;} private _lastEditDateTime: moment.Moment;           
}
